import type { ComponentType, ReactNode } from 'react';
import { Text, theme } from '@frameio/vapor';
import styles from './FeatureHighlights.module.css';

export type FeatureHighlight = {
  description: string;
  icon: ComponentType<{ color?: string }>;
  title: string;
};

const titleStyles = {
  fontSize: theme.fontSizes[80],
};

const descriptionStyles = {
  fontSize: theme.fontSizes[50],
};

type FeatureHighlightsProps = {
  features: readonly FeatureHighlight[];
  heading?: ReactNode;
  iconColor: string;
};

export function FeatureHighlights({
  features,
  heading,
  iconColor,
}: FeatureHighlightsProps) {
  return (
    <div className={styles.container}>
      {heading && (
        <Text color="secondary" style={descriptionStyles} variant="body">
          {heading}
        </Text>
      )}
      {features.map((feature) => (
        <div key={feature.title} className={styles.feature}>
          <div className={styles.icon}>
            <feature.icon color={iconColor} />
          </div>
          <div>
            <Text color="primary" style={titleStyles} variant="header">
              {feature.title}
            </Text>
            <Text color="secondary" style={descriptionStyles} variant="body">
              {feature.description}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
}
